import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelTransformer, DiffBase, DiffBaseProps } from '../diff-base';
import { BooleanCandidatePreofferInfoDataFields } from '@innowise-group/core';

interface BooleanCandidatePreofferInfoDiff extends Omit<DiffBaseProps, 'labelTransformer'> {
  fieldName: BooleanCandidatePreofferInfoDataFields;
}

const BooleanCandidatePreofferInfoDiff: FC<BooleanCandidatePreofferInfoDiff> = (props) => {
  const { fieldName } = props;
  const { t } = useTranslation();

  const labelTransformer: LabelTransformer<typeof fieldName> = ({ data }) => t(`buttons.${data ? 'yes' : 'no'}`);

  return <DiffBase fieldName={fieldName} labelTransformer={labelTransformer} {...props} />;
};

export default BooleanCandidatePreofferInfoDiff;
